import { Helmet } from "react-helmet-async";

/**
 * Site-wide JSON-LD injected once at the App root — provides Organization and
 * WebSite entities so search + AI answer engines have a stable brand identity
 * to attach every page-level schema to. Kept intentionally short & quotable.
 */
export default function SiteJsonLd() {
  const org = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Booty Breeze",
    "url": "https://bootybreeze.com",
    "logo": "https://bootybreeze.com/icon-512.png",
    "description":
      "Booty Breeze is a US-based small-batch adult (18+) novelty car air freshener brand. Hand-poured, cured for slow release, and designed to last 3–4 weeks in a daily driver. Free shipping on U.S. orders over $10.",
    "email": "admin@bootybreeze.com",
    "areaServed": ["US", "CA", "GB", "AU"],
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "admin@bootybreeze.com",
      "contactType": "customer support",
    },
  };
  const site = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "url": "https://bootybreeze.com",
    "name": "Booty Breeze",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://bootybreeze.com/shop?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(org)}</script>
      <script type="application/ld+json">{JSON.stringify(site)}</script>
    </Helmet>
  );
}
